import {
    createLocaleTextWithDevI18nKey,
    getLocale,
    setLocale,
    useLocaleText,
    type LocaleTextPrinter,
} from '@meitu/xdesign-i18n';
import { CLIENT_LOCALE } from './constants';
import { localeTextMap, type LocaleCode, type LocaleText } from './locales';

type LocaleStore = {
    locale: LocaleCode;
    $t: LocaleTextPrinter<LocaleText>;
};

const localStoreCache: Partial<Record<LocaleCode, LocaleStore>> = {};

export const initLocaleStore = (locale: LocaleCode) => {
    setLocale(locale);
};

export const getLocaleStore = (_locale?: LocaleCode) => {
    const requestedLocale = _locale || getLocale();
    // 模块级文案可能在 initLocaleStore 执行前读取，不能缓存空语言包
    const locale: LocaleCode =
        requestedLocale === 'en' || requestedLocale === 'zh-Hans' ? requestedLocale : CLIENT_LOCALE;
    const localeText = localeTextMap[locale];

    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale,
            $t: createLocaleTextWithDevI18nKey(localeText as unknown as Record<string, unknown>),
        } as unknown as LocaleStore;
    }

    return localStoreCache[locale]!;
};

export const useLocaleStore = () => {
    const locale = useLocaleText<LocaleCode>();

    return getLocaleStore(locale);
};
